import React, {useRef} from "react";
import PrintOptionsModal from "../Utils/PrintOptionsModal";



export default function PrintServiceRecordModal({open, setOpen, handleServicePrint, handleCustomerServicePrint}){
    let conf = [
        {
            label: "Print Service Record",
            color: "warning",
            onClick: handleServicePrint
        },
        {
            label: "Print Customer Service Record",
            color: "warning",
            onClick: handleCustomerServicePrint
        }
    ]
    return (
        <PrintOptionsModal
            conf={conf}
            open={open}
            setOpen={setOpen}
        />
    )

}